import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class VerticalProfileService {
  // we do this check, because most of otherwise, the slice is just not changing. 
  public inlineSliceData = signal<any[]>([], {
    equal: (a, b) => {
      if (a.length !== b.length) return false;
      return JSON.stringify(a) === JSON.stringify(b);
    }
  })
  public xMin = signal<number>(0)
  public xMax = signal<number>(5000)
}
